// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"e018210b","57":"306b6de7","400":"2add8f1b","520":"d94bf7c3","566":"1fdd454c","885":"f713a7b6"}[chunkId] + ".chunk.js";
};